<template>
    <div class="template-detail-cards">
        <slot>
            <!-- 기본 플레이스홀더 카드들 (4개) -->
            <div v-for="i in 4" :key="i" class="detail-card">
                <div class="card-header">
                    <div class="card-title">카드 제목 {{ i }}</div>
                </div>
                <div class="card-body">
                    <div class="card-content">카드 내용을 여기에 표시합니다</div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: "TemplateDetailCards",
};
</script>

<style scoped>
.template-detail-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

.detail-card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.card-header {
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
}

.card-title {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
}

.card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.card-content {
    font-size: 12px;
    color: #64748b;
    line-height: 1.5;
}
</style>
